import {NodeFormBuilder} from "../../../../../../../shared/models";
import {FormArray, FormControl, FormGroup} from "@angular/forms";
import {required} from "../../../../../../../shared/utils";
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';

export const NODE_TYPE = "orca_payment";

export interface LineItem {
    name: string,
    label: string,
    amount: string,
}

export interface OrcaPaymentForm {
    name: string
    menuHeader: string,
    imageRef: string,
    currencyCode: string,
    countryCode: string,
    capabilities: string[],
    supportedNetworks: string[],
    lineItem: LineItem[],
    completedNext: string,
    completedDescription: string,
    declinedNext: string,
    declinedDescription: string,
    unknownNext: string,
    unknownDescription: string,
}


export class OrcaPayment extends NodeFormBuilder<OrcaPaymentForm> {

    constructor() {
        super("menu", NODE_TYPE);
    }

    buildForm(formData: OrcaPaymentForm, editFlows: boolean): FormGroup {

        const capabilities = new FormArray([])
        const supportedNetworks = new FormArray([])
        const lineItem = new FormArray([])

        for (let capability of formData.capabilities) {
            capabilities.push(new FormControl(capability))
        }

        for (let network of formData.supportedNetworks) {
            supportedNetworks.push(new FormControl(network))
        }

        for (let item of formData.lineItem) {
            lineItem.push(new FormGroup({
                name: new FormControl({
                    value: item.name,
                    disabled: !editFlows
                }),
                amount: new FormControl({
                    value: item.amount,
                    disabled: !editFlows
                }),
                label: new FormControl({
                    value: item.label,
                    disabled: !editFlows
                }),
            }))
        }

        return new FormGroup({
            name: new FormControl({
                value: formData.name,
                disabled: !editFlows
            }),
            menuHeader: new FormControl({
                value: formData.menuHeader,
                disabled: !editFlows
            }, required('Title')),
            imageRef: new FormControl({
                value: formData.imageRef,
                disabled: !editFlows
            }),
            currencyCode: new FormControl({
                value: formData.currencyCode,
                disabled: !editFlows
            }),
            countryCode: new FormControl({
                value: formData.countryCode,
                disabled: !editFlows
            }),
            capabilities,
            supportedNetworks,
            lineItem,
            completedNext: new FormControl({
                value: formData.completedNext,
                disabled: !editFlows
            }),
            completedDescription: new FormControl({
                value: formData.completedDescription,
                disabled: !editFlows
            }),
            declinedNext: new FormControl({
                value: formData.declinedNext,
                disabled: !editFlows
            }),
            declinedDescription: new FormControl({
                value: formData.declinedDescription,
                disabled: !editFlows
            }),
            unknownNext: new FormControl({
                value: formData.unknownNext,
                disabled: !editFlows
            }),
            unknownDescription: new FormControl({
                value: formData.unknownDescription,
                disabled: !editFlows
            }),

        });
    }

    getFromData(stepData: { [index: string]: any }): OrcaPaymentForm {
        const menu = stepData?.menu ? stepData?.menu : {};
        const menuParams = menu?.menuParams ? menu?.menuParams : {};
        const result = menu?.result ? menu?.result : {};

        const merchantInfo = menuParams?.merchantInfo ? menuParams?.merchantInfo : {}

        const lineItems = menu?.lineItems ? menu?.lineItems : {"": {amount: "", label: ""}};

        const lineItem: LineItem[] = [];
        for (let key of Object.keys(lineItems)) {
            const item = lineItems[key];

            lineItem.push({
                name: key,
                amount: item.amount,
                label: item.label
            });

        }

        const completedResult = result["PAYMENT_COMPLETED"] ? result["PAYMENT_COMPLETED"] : {};
        const declinedResult = result["PAYMENT_DECLINED"] ? result["PAYMENT_DECLINED"] : {};
        const unknownResult = result["UNKNOWN"] ? result["UNKNOWN"] : {};

        return {
            name: this.getValueOrDefault(menu?.name),
            menuHeader: this.getValueOrDefault(menu?.menuHeader),
            imageRef: this.getValueOrDefault(menu?.imageRef),
            currencyCode: this.getValueOrDefault(menuParams?.currencyCode, "USD"),
            countryCode: this.getValueOrDefault(menuParams?.countryCode, "US"),

            capabilities: this.getValueOrDefault(merchantInfo?.capabilities, ['supports3DS', 'supportsDebit', 'supportsCredit']),
            supportedNetworks: this.getValueOrDefault(merchantInfo?.supportedNetworks, ['amex', 'visa', 'discover', 'masterCard']),

            lineItem,

            completedNext: this.getValueOrDefault(completedResult?.next, newStepValue),
            completedDescription: this.getValueOrDefault(completedResult?.description, "Payment Succeeds"),
            declinedNext: this.getValueOrDefault(declinedResult?.next, newStepValue),
            declinedDescription: this.getValueOrDefault(declinedResult?.description, "Payment Failed"),
            unknownNext: this.getValueOrDefault(unknownResult?.next, newStepValue),
            unknownDescription: this.getValueOrDefault(unknownResult?.description, "Payment Unknown"),
        };
    }


    setNodeData(nodeData: OrcaPaymentForm) {

        const {
            name,
            menuHeader,
            imageRef,
            currencyCode,
            countryCode,
            capabilities,
            supportedNetworks,
            lineItem,
            completedNext,
            declinedNext,
            declinedDescription,
            unknownDescription,
            completedDescription,
            unknownNext,
        } = nodeData;

        const merchantInfo = {
            capabilities,
            supportedNetworks
        }

        const lineItems = {}

        for (let item of lineItem) {
            lineItems[item.name] = {
                label: item.label,
                amount: item.amount,
            }
        }

        const menuParams = {
            merchantInfo,
            currencyCode,
            countryCode,
            lineItems
        }

        const results = {
            "PAYMENT_COMPLETED": {
                description: completedDescription,
                next: completedNext,
            },
            "PAYMENT_DECLINED": {
                description: declinedDescription,
                next: declinedNext,
            },
            "UNKNOWN": {
                description: unknownDescription,
                next: unknownNext,
            }
        }

        this.menu = {
            ...this.menu,
            name,
            menuHeader,
            imageRef,
            menuParams,
            results
        }

    }

}


// {
//     menu: {
//             name: '',
//             menuType: 'orca_payment',
//             menuHeader: '',
//             imageRef: '',
//             menuParams: {
//                 currencyCode: 'USD',
//                 countryCode: 'US',
//                 merchantInfo: {
//                   capabilities: ['supports3DS', 'supportsDebit', 'supportsCredit'],
//                   supportedNetworks: ['amex', 'visa', 'discover', 'masterCard'],
//                 },
//                 lineItems: {
//                 '': {
//                     label: '',
//                     amount: '',
//                 },
//             },
//         },
//         results: {
//             PAYMENT_COMPLETED: {
//                 description: 'Payment Succeeds',
//                     next: newStepValue,
//             },
//             PAYMENT_DECLINED: {
//                 description: 'Payment Failed',
//                     next: newStepValue,
//             },
//             UNKNOWN: {
//                 description: 'Payment Unknown',
//                     next: newStepValue,
//             },
//         },
//     },
//     type: 'menu',
//         metadata: {},
// }